export const PageHeader = ({ overline, title, subtitle }) => (
  <section className="bg-[hsl(var(--muted))] border-b border-border">
    <div className="container-page py-16 lg:py-20 text-center max-w-3xl mx-auto animate-fade-up">
      {overline && (
        <p className="text-sm uppercase tracking-[0.2em] font-semibold text-secondary">{overline}</p>
      )}
      <h1 className="font-heading text-5xl md:text-6xl text-primary mt-3 leading-tight">{title}</h1>
      {subtitle && <p className="text-lg md:text-xl text-muted-foreground mt-5 leading-relaxed">{subtitle}</p>}
    </div>
  </section>
);
